<template>
  <GlobalWindow
    :visible.sync="isVisibled"
    :show="true"
    title="复制"
    width="80%"
    @confirm="confirm"
    @close="(selectData = []),(currency = [{ cropNum: '', crop: '0',is_title: '0',is_notice: '0', is_repeat_submit: '0'}]), $emit('guanbi')"
  >
    <div class="top">
      <el-row :gutter="10">
        <el-col :span="8">
          <el-input
            v-model="advertiserListParams.name"
            placeholder="请输入广告主名称"
            @input="($event)=>{
              advertiserListParams.name = handleParams($event)
            }"
          >
            <i
              slot="prefix"
              class="el-input__icon el-icon-search"
            />
          </el-input>
        </el-col>
        <el-button
          type="primary"
          @click="search"
        >搜索</el-button>
        <el-button
          type="primary"
          @click="reset"
        >重置</el-button>
        <el-button
          type="primary"
          @click="clearSelect"
        >清空选项</el-button>
      </el-row>
    </div>

    <div class="center-container">

      <!-- 左侧 -->
      <div class="center-left">
        <el-table
          v-if="advertiserList"
          ref="multipleTable"
          v-loading="isLoading"
          :data="advertiserList"
          :row-key="getRowKeys"
          border
          tooltip-effect="dark"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55"
            :reserve-selection="true"
          />
          <el-table-column
            prop="id"
            label="ID"
            width="60"
          />
          <el-table-column
            prop="account_id"
            label="account_id"
            width="100"
          />
          <el-table-column
            prop="account_name"
            width="220"
            label="广告主名称"
            show-overflow-tooltip
          />
          <el-table-column label="复制的量" width="100">
            <template slot-scope="scope">
              <input

                v-if="selectData.filter((item)=>{
                  return item.id === scope.row.id
                }).length"

                v-model="selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0].num"

                class="input"
                type="number"
                min="1"
                max="50"
                placeholder="复制的量"

                @input="judge(selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0],$event)"
              >
            </template>
          </el-table-column>
          <el-table-column width="150" label="文字">
            <template slot-scope="scope">
              <el-input
                v-if="selectData.filter((item)=>{
                  return item.id === scope.row.id
                }).length"
                v-model="selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0].text_arr"

                placeholder="请输入文字"
                @input="($event)=>{
                  selectData.filter((item)=>{
                    return item.id === scope.row.id
                  })[0].text_arr = handleParams($event)
                }"
              />
            </template>
          </el-table-column>
          <!-- <el-table-column label="截止天数">
            <template slot-scope="scope">
              <el-input
                v-if="selectData.filter((item)=>{
                  return item.id === scope.row.id
                }).length"
                v-model="selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0].tianshu"

                placeholder="请输入内容"
              />
            </template>
          </el-table-column> -->
          <!-- <el-table-column label="时间间隔（分）">
            <template slot-scope="scope">
              <input
                v-if="selectData.filter((item)=>{
                  return item.id === scope.row.id
                }).length"
                v-model="selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0].jiange"
                type="number"
                class="input"
                min="30"
                placeholder="请输入内容"
                @blur="judges(selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0],$event)"
              >
            </template>
          </el-table-column> -->
          <el-table-column label="是否裁剪" width="120">
            <template slot-scope="scope">
              <el-select
                v-if="selectData.filter((item)=>{
                  return item.id === scope.row.id
                }).length"
                v-model="selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0].crop"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in optionsCrop"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="是否修改标题" width="120">
            <template slot-scope="scope">
              <el-select
                v-if="selectData.filter((item)=>{
                  return item.id === scope.row.id
                }).length"
                v-model="selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0].is_title"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="是否通知" width="100">
            <template slot-scope="scope">
              <el-select
                v-if="selectData.filter((item)=>{
                  return item.id === scope.row.id
                }).length"
                v-model="selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0].is_notice"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="是否重复提交" width="120">
            <template slot-scope="scope">
              <el-select
                v-if="selectData.filter((item)=>{
                  return item.id === scope.row.id
                }).length"
                v-model="selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0].is_repeat_submit"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            label="关联计划"
            prop="server_name"
            width="200"
            show-overflow-tooltip
          >
            <template v-if="shifou(scope.row)" slot-scope="scope">
              <div style="position: relative">
                <el-autocomplete
                  v-model="selectData.filter((item)=>{
                    return item.id === scope.row.id
                  })[0].jihua"
                  :popper-append-to-body="false"
                  :fetch-suggestions="querySearchAsync"
                  :placeholder="myItem === '目标不一致' ? '已禁选' : '请输入计划'"
                  :disabled="myItem === '目标不一致' ? true : false"

                  @select="handleSelect"
                  @focus="acID = scope.row.account_id"
                  @input="handleChange"
                >
                <!-- <template slot-scope="scope">
                  <span :title="scope.item.value">{{ scope.item.value }}</span>
                </template> -->
                </el-autocomplete>
                <!-- <i
                  class="el-icon-arrow-down"
                  style="position: absolute; top: 50%;transform: translateY(-50%); right: 1px;"
                /> -->
              </div>

            </template>
          </el-table-column>
          <el-table-column label="原生页类型" width="120">
            <template scope="scope">
              <el-select
                v-if="selectData.filter((item)=>{
                  return item.id === scope.row.id
                }).length"
                v-model="selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0].wechat_page_type"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in [{value: 1, label: '自建'}, {value: 2, label: '授权'},{value: 3, label: '转拼音'}]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </template>

          </el-table-column>
          <el-table-column label="有效日期" width="320">
            <template
              scope="scope"
            >
              <div
                v-if="selectData.filter((item)=>{
                  return +item.id === +scope.row.id
                }).length"
                style="display: flex; align-items: center;"
              >
                <el-date-picker
                  v-model="selectData.filter((item)=>{
                    return +item.id === +scope.row.id
                  })[0].begin_time"
                  :picker-options="{disabledDate: (date)=>{ return date.getTime() < (+new Date() - (24 * 60 * 60 * 1000)) }}"
                  value-format="yyyy-MM-dd"
                  type="date"
                  style="width: 138px"
                  placeholder="开始日期"
                  @change="myDatePicker($event, selectData.filter((item)=>{
                    return +item.id === +scope.row.id
                  })[0], 'begin_time')"
                />

                ---

                <el-date-picker
                  v-if="selectData.filter((item)=>{
                    return +item.id === +scope.row.id
                  })[0].end_time !== '长期'"
                  v-model="selectData.filter((item)=>{
                    return +item.id === +scope.row.id
                  })[0].end_time"
                  :disabled="selectData.filter((item)=>{
                    return +item.id === +scope.row.id
                  })[0].begin_time ? false : true"
                  :picker-options="{
                    disabledDate: (date)=>{ return date.getTime() < +new Date(selectData.filter((item)=>{
                      return +item.id === +scope.row.id
                    })[0].begin_time) },
                    shortcuts: [{
                      text: '长期',
                      onClick: ()=>{ longTerm(selectData.filter((item)=>{
                        return +item.id === +scope.row.id
                      })[0]) }
                    }]
                  }"
                  value-format="yyyy-MM-dd"
                  type="date"
                  style="width: 138px"
                  placeholder="结束日期"
                  @change="myDatePicker($event, selectData.filter((item)=>{
                    return +item.id === +scope.row.id
                  })[0], 'end_time')"
                />
                <el-tag
                  v-else
                  closable
                  @close="longTerm(selectData.filter((item)=>{
                    return +item.id === +scope.row.id
                  })[0], null)"
                >长期</el-tag>
              </div>

            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 右侧 -->
      <div
        v-if="Object.keys(selectData).length !== 0"
        style="display: flex; flex-direction: column; justify-content: space-between; overflow: hidden;"
      >
        <div
          class="center-right"
          style="max-height:430px"
        >
          <h3>已选：</h3>
          <el-table
            :data="selectData"
            border
            style="width: 100%"
          >
            <el-table-column
              prop="id"
              label="ID"
              width="70"
            />
            <el-table-column
              prop="account_id"
              label="account_id"
              width="150"
            />
            <el-table-column
              prop="account_name"
              label="广告主名称"
              width="220"
            >
              <template scope="scope">
                <el-popover
                  placement="top-start"
                  title="广告主名称"
                  width="220"
                  trigger="hover"
                  :content="scope.row.account_name"
                >
                  <p slot="reference" class="titip" style="width: 220px">{{ scope.row.account_name }}</p>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column
              prop="num"
              label="复制的量"
              width="100"
            />
            <el-table-column
              prop="text_arr"
              label="文字"
              width="150"
            />
            <el-table-column
              prop="jihua"
              label="关联计划"
              width="180"
            >
              <template scope="scope">
                <el-popover
                  placement="top-start"
                  title="关联计划"
                  width="200"
                  trigger="hover"
                  :content="scope.row.jihua"
                >
                  <p slot="reference" class="titip">{{ scope.row.jihua }}</p>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column
              prop="crop"
              label="是否裁剪"
              width="100"
            >
              <template scope="scope">{{ selectOption(scope.row.crop) }}</template>
            </el-table-column>

            <el-table-column
              prop="is_title"
              label="是否修改标题"
              width="120"
            >
              <template scope="scope">{{ scope.row.is_title === '1' ? '是':'否' }}</template>
            </el-table-column>

            <el-table-column
              prop="is_notice"
              label="是否通知"
              width="100"
            >
              <template scope="scope">{{ scope.row.is_notice === '1' ? '是':'否' }}</template>
            </el-table-column>

            <el-table-column
              prop="is_repeat_submit"
              label="是否重复提交"
              width="120"
            >
              <template scope="scope">{{ scope.row.is_repeat_submit === '1' ? '是':'否' }}</template>
            </el-table-column>

            <el-table-column prop="wechat_page_type" label="原生页类型" width="100">
              <template scope="scope">{{ scope.row.wechat_page_type === 1 ? '自建' : scope.row.wechat_page_type === 2 ? '授权' : '转拼音' }}</template>
            </el-table-column>

            <el-table-column label="有效日期" width="300">
              <template scope="scope">
                {{ scope.row.begin_time }}
                ---
                {{ scope.row.end_time }}
              </template>
            </el-table-column>
          </el-table>

        </div>

        <div class="center-right">
          <h3 style="margin-bottom: 4px;">通用改动：此改动会影响全局</h3>

          <el-table
            :data="currency"
            border
            style="width: 100%"
          >
            <el-table-column
              label="复制的量"
              width="120"
            >
              <template scope="scope">
                <el-input v-model="scope.row.cropNum" placeholder="请输入复制的量" @input="scope.row.cropNum = $event.replace(/[^\d]/g, ''),handleCurrencyCropNum()" />
              </template>
            </el-table-column>
            <el-table-column
              label="文字"
              width="200"
            >
              <template scope="scope">
                <el-input
                  v-model="scope.row.text_arr"
                  placeholder="请输入文字"
                  @input="scope.row.text_arr = handleParams($event), selectData.forEach(item => item.text_arr = scope.row.text_arr)"
                />
              </template>
            </el-table-column>
            <el-table-column
              label="是否裁剪"
              width="120"
            >
              <template scope="scope">
                <el-select
                  v-model="scope.row.crop"
                  placeholder="请选择"
                  @change="selectData.forEach(item => item.crop = $event)"
                  @visible-change="$event === false && selectData.forEach(item => item.crop = scope.row.crop)"
                >
                  <el-option
                    v-for="item in optionsCrop"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              label="是否修改标题"
              width="120"
            >
              <template scope="scope">
                <el-select
                  v-model="scope.row.is_title"
                  placeholder="请选择"
                  @change="selectData.forEach(item => item.is_title = $event)"
                  @visible-change="$event === false && selectData.forEach(item => item.is_title = scope.row.is_title)"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              label="是否通知"
              width="100"
            >
              <template scope="scope">
                <el-select
                  v-model="scope.row.is_notice"
                  placeholder="请选择"
                  @change="selectData.forEach(item => item.is_notice = $event) "
                  @visible-change="$event === false && selectData.forEach(item => item.is_notice = scope.row.is_notice)"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              label="是否重复提交"
              width="120"
            >
              <template scope="scope">
                <el-select
                  v-model="scope.row.is_repeat_submit"
                  placeholder="请选择是否重复提交"
                  @change="selectData.forEach(item => item.is_repeat_submit = $event) "
                  @visible-change="$event === false && selectData.forEach(item => item.is_repeat_submit = scope.row.is_repeat_submit)"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="原生页类型" width="120">
              <template scope="scope">
                <el-select
                  v-model="scope.row.wechat_page_type"
                  placeholder="请选择是否重复提交"
                  @change="selectData.forEach(item => item.wechat_page_type = $event) "
                  @visible-change="$event === false && selectData.forEach(item => item.wechat_page_type = scope.row.wechat_page_type)"
                >
                  <el-option
                    v-for="item in [{value: 1, label: '自建'}, {value: 2, label: '授权'},{value: 3, label: '转拼音'}]"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </template>

            </el-table-column>

            <el-table-column label="有效日期" width="320">

              <template
                scope="scope"
              >
                <div
                  style="display: flex; align-items: center;"
                >
                  <el-date-picker
                    v-model="scope.row.begin_time"
                    :picker-options="{disabledDate: (date)=>{ return date.getTime() < (+new Date() - (24 * 60 * 60 * 1000)) }}"
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 138px"
                    placeholder="开始日期"
                    @change="myDatePicker1($event, scope.row, 'begin_time')"
                  />

                  ---

                  <el-date-picker
                    v-if="scope.row.end_time !== '长期'"
                    v-model="scope.row.end_time"
                    :disabled="scope.row.begin_time ? false : true"
                    :picker-options="{
                      disabledDate: (date)=>{ return date.getTime() < +new Date(scope.row.begin_time) },
                      shortcuts: [{
                        text: '长期',
                        onClick: ()=>{ longTerm1(scope.row) }
                      }]
                    }"
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 138px"
                    placeholder="结束日期"
                    @change="myDatePicker1($event, scope.row, 'end_time')"
                  />
                  <el-tag v-else closable @close="longTerm1(scope.row, null)">长期</el-tag>
                </div></template>
            </el-table-column>
          </el-table>

        </div>
      </div>

    </div>

    <span v-if="myItem === '目标不一致'">提示：由于有推广目标不一致，所以关联计划禁选</span>
    <Pagination
      :total="total"
      :page.sync="advertiserListParams.page"
      :limit.sync="advertiserListParams.page_size"
      :auto-scroll="false"
      @pagination="fetchAvertiserList"
    />
  </GlobalWindow>
</template>

<script>
import GlobalWindow from '@/components/GlobalWindow.vue'
import Pagination from '@/components/Pagination/index'
import { advertiserList, copyAdqAdvert, shous } from '@/api/customer/accountList/copyAdvertManage'
export default {
  name: 'CopyAdqAdDialog',
  components: {
    GlobalWindow,
    Pagination
  },
  props: {
    adgroup_ids: {}
  },
  data() {
    return {
      isVisibled: false,
      isLoading: false,
      total: 0,
      advertiserListParams: {
        name: null,
        type: 2,
        page: 1,
        page_size: 10
      },
      selectData: [],
      advertiserList: null,
      copyAdvertParams: {
        account_ids: [],
        account_id: null,
        adgroup_id: null
      },
      acID: null,
      myItem: null,
      options: [{
        value: '1',
        label: '是'
      }, {
        value: '0',
        label: '否'
      }],
      optionsCrop: [{
        value: '0',
        label: '不裁剪'
      }, {
        value: '1',
        label: '裁剪'
      }, {
        value: '2',
        label: '四宫格'
      }, {
        value: '3',
        label: '模糊化'
      }
      ],
      associatedPlans: [],
      currency: [{ // 控制修改通用的
        cropNum: '',
        crop: '0',
        is_title: '0',
        is_notice: '0',
        is_repeat_submit: '0',
        wechat_page_type: 2,
        begin_time: null,
        end_time: null
      }]
    }
  },
  created() {
    window.pok = this
  },
  methods: {

    selectOption(crop) {
      for (let i = 0; i < this.optionsCrop.length; i++) {
        if (this.optionsCrop[i].value === crop) {
          return this.optionsCrop[i].label
        }
      }
    },
    getRowKeys(row) {
      return row.id // 每条数据的唯一识别值
    },
    open(item = {}) {
      this.fetchAvertiserList()
      this.isVisibled = true
      this.myItem = item
    },

    longTerm(row, my) {
      const index1 = this.selectData.findIndex(item => +item.id === +row.id)
      this.$set(this.selectData[index1], 'end_time', my === null ? null : '长期')
    },

    longTerm1(row, my) {
      this.$set(this.currency[0], 'end_time', my === null ? null : '长期')
      for (let i = 0; i < this.selectData.length; i++) {
        this.$set(this.selectData[i], 'end_time', my === null ? null : '长期')
      }
    },

    myDatePicker(date, row, type) {
      const index = this.selectData.findIndex(item => +item.id === +row.id)
      this.$set(this.selectData[index], type, date)
    },

    myDatePicker1(date, row, type) {
      for (let i = 0; i < this.selectData.length; i++) {
        this.$set(this.selectData[i], type, date)
      }
    },

    // 获取广告主列表
    fetchAvertiserList() {
      this.isLoading = true
      advertiserList(this.advertiserListParams).then(res => {
        this.advertiserList = res.data.list
        this.total = res.data.total
        this.isLoading = false
      })
    },
    clearSelect() {
    //  this.$refs.multipleTable.clearSelection()
    },
    handleSelectionChange(data) {
      const res = []
      const datas = []
      data.forEach(item => {
        res.push(item.account_id)
        const s4 = this.selectData.filter((it) => {
          return it.id === item.id
        })
        datas.push({
          ...item,
          num: s4.length ? s4[0].num : '1', // 复制的量
          text_arr: s4.length ? s4[0].text_arr : null, // 文字
          jihua: s4.length ? s4[0].jihua : null, // 关联计划
          tianshu: s4.length ? s4[0].tianshu : '0', // 截止天数
          jiange: s4.length ? s4[0].jiange : '0', // 时间间隔
          crop: s4.length ? s4[0].crop : '0', // 是否裁剪
          is_title: s4.length ? s4[0].is_title : '0', // 是否修改标题
          is_notice: s4.length ? s4[0].is_notice : '0', // 是否通知
          is_repeat_submit: s4.length ? s4[0].is_repeat_submit : '0', // 是否重复提交
          wechat_page_type: s4.length ? s4[0].wechat_page_type : 2, // 原生页类型
          begin_time: s4.length ? s4[0].begin_time : null, // 开始日期
          end_time: s4.length ? s4[0].end_time : null // 结束日期
        })
      })
      this.selectData = datas
      this.copyAdvertParams.account_ids = res
    },
    // 复制广告
    copyAdqAdvert(params) {
      if (!this.copyAdvertParams.account_ids) {
        this.$message({
          message: '请选择广告主',
          type: 'error'
        })
        return
      }
      const obj = {}
      for (let i = 0; i < this.selectData.length; i++) {
        obj[this.selectData[i].account_id] = +this.selectData[i].num
      }

      copyAdqAdvert({
        ...params,
        account_ids: obj,
        adgroup_ids: this.adgroup_ids
      }).then(res => {
        this.$message({
          message: res.message,
          type: 'success'
        })
        this.copyAdvertParams.account_ids = null
        this.isVisibled = false
      })
    },

    search() {
      this.advertiserListParams.page = 1
      this.fetchAvertiserList()
    },

    reset() {
      this.advertiserListParams = {
        name: null,
        type: 2,
        page: 1,
        page_size: 10
      }
      this.fetchAvertiserList()
    },

    confirm() {
      console.log('this.copyAdvertParams.account_ids:', this.copyAdvertParams.account_ids)
      if (!this.copyAdvertParams.account_ids) {
        this.$message({
          message: '请选择广告主',
          type: 'error'
        })
        return
      }

      if (!this.judgmentDate()) {
        return
      }

      const arr = []
      for (let i = 0; i < this.selectData.length; i++) {
        arr.push({
          account: this.selectData[i].account_id,
          num: this.selectData[i].num,
          text_arr: this.selectData[i].text_arr, // 文字
          campaign_id: this.selectData[i].campaign_id ? this.selectData[i].campaign_id : 0,
          campaign_name: this.selectData[i].campaign_id ? null : this.selectData[i].jihua,
          repetition_days: this.selectData[i].tianshu,
          repetition_interval: this.selectData[i].jiange,
          is_crop: this.selectData[i].crop,
          is_title: this.selectData[i].is_title,
          is_notice: this.selectData[i].is_notice,
          is_repeat_submit: this.selectData[i].is_repeat_submit,
          wechat_page_type: this.selectData[i].wechat_page_type,
          begin_time: this.selectData[i].begin_time || 0,
          end_time: this.selectData[i].end_time === '长期' ? '2111-01-01' : this.selectData[i].end_time ? this.selectData[i].end_time : 0
        })
      }
      this.$emit('qindian', arr, () => {
        this.copyAdvertParams.account_ids = null
        this.isVisibled = false
        this.currency = [{ // 控制修改通用的
          cropNum: '',
          crop: '0',
          is_title: '0',
          is_notice: '0',
          is_repeat_submit: '0'
        }]
      })
    },

    // 判断日期
    judgmentDate() {
      for (let i = 0; i < this.selectData.length; i++) {
        if (this.selectData[i].begin_time && !this.selectData[i].end_time) {
          this.$message({
            message: `${this.selectData[i].account_id}  必须选开始时间`,
            type: 'warning'
          })
          return false
        }
        if (!this.selectData[i].begin_time && this.selectData[i].end_time) {
          this.$message({
            message: `${this.selectData[i].account_id}  必须选结束时间`,
            type: 'warning'
          })
          return false
        }
      }

      return true
    },

    judge(item, event) {
      const text = event.target.value
      console.log('event.target.value', event.target.value)
      if (Number(text) < 1) {
        text === '' ? item.num = 1 : item.num = Math.abs(text)
      } else if (Number(text) > 50) {
        text === '' ? item.num = 1 : item.num = 50
      }
    },

    judges(item, event) {
      const text = event.target.value
      console.log('text', text)
      console.log()
      if (Number(text) < 30 && Number(text) !== 0) {
        item.jiange = 30
      }
    },

    querySearchAsync(queryString, callback) {
      var list = [{}]
      shous({
        account_id: this.acID,
        campaign_name: this.selectData.filter((item) => {
          return item.account_id === this.acID
        })[0].jihua,
        promoted_object_type: this.myItem.promoted_object_type
      }).then((response) => {
        for (const i of response.data.list) {
          i.value = i.campaign_name // 想要展示的数据 // 将想要展示的数据作为value
        }
        list = response.data.list
        callback(list)
      })
    },

    handleSelect(item1) {
      this.selectData.forEach((item) => {
        if (item.account_id === this.acID) {
          item.jihua = item1.campaign_name
          item.campaign_id = item1.campaign_id
        }
      })
    },

    shifou(row) {
      return !!this.selectData.filter((item) => {
        return item.account_id === row.account_id
      }).length
    },

    handleChange(value) {
      const item = this.selectData.filter((item) => {
        return this.acID === item.account_id
      })
      if (item.length && item[0].campaign_id) {
        (item[0].campaign_id !== value) && (item[0].campaign_id = undefined)
      }
    },

    async getFocus() {
      const response = await shous({
        account_id: this.acID,
        promoted_object_type: this.myItem.promoted_object_type
      })
      this.associatedPlans = response.data.list.map((item) => {
        return {
          ...item,
          value: item.campaign_name
        }
      })
    },

    handleCurrencyCropNum() {
      if (!this.currency[0].cropNum) {
        return
      }
      this.selectData.forEach((item) => {
        item.num = this.currency[0].cropNum
      })
    },

    handleParams(value) {
      console.log(value)
      const str = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、 ]/img
      // this.advertiserListParams.name = value.replace(str, ',')
      const temp = value.replace(str, ',')
      const str1 = /(,){1,}/img
      // this.advertiserListParams.name = this.advertiserListParams.name.replace(str1, ',')
      const temp1 = temp.replace(str1, ',')
      return temp1
    }
  }
}
</script>

<style lang="less" scoped>
.center-container {
  margin-top: 20px;
  display: flex;
  .center-left {
    width: 70%;
  }
  .center-right {
    margin-left: 25px;
    // width: 500px;
    // max-height: 500px;
    overflow: auto;
    td {
      padding: 4px;
    }
  }

  .input{
    height: 30px;
    width: 69px;
    padding-left: 5px;
    border: 1px solid #bfbfbf;
    border-radius: 5px;
  }
}
 ::v-deep .el-popper[x-placement^=bottom]{
		width:400px !important;
	}
 ::v-deep .center-container .center-left{
      width: 60%;
 }
 .titip{
    width: 70px;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; /* 这里是超出几行省略 */
    overflow: hidden;
}
</style>
